/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2025-06-05 09:46:58
 * @LastEditors: linxi
 * @LastEditTime: 2025-08-01 17:37:12
 */
import React, { ReactElement, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { TabBar, TabPane } from '../../compnents/widgets/TabBar'
import { EAFConserveList } from './EAFConserve/EAFConserve'
import { EAFConserveRecordList } from './EAFConserveRecord/EAFConserveRecord'
import { EAFRegisterList } from './EAFRegister/EAFRegister'
import { EAFRegisterRecordList } from './EAFRegisterRecord/EAFRegisterRecord'
import { EAFUseList } from './EAFUse/EAFUse'
import { EAFUseRecordList } from './EAFUseRecord/EAFUseRecord'
export const EquipmentAndFacilitiesManagementTabs = (): ReactElement => {
  const location: any = useLocation()

  const [selectKey, setSelectKey] = useState<any>('0')

  return (
    <TabBar
      style={{ margin: '10px 20px' }}
      defaultActiveKey={
        location.state ? location.state.selectKey : selectKey || '0'
      }
      onChange={(v) => {
        setSelectKey(v)
      }}
    >
      <TabPane key='0' tab='设备设施登记'>
        <EAFRegisterList selectKey={selectKey}></EAFRegisterList>
      </TabPane>
      <TabPane key='1' tab='设备设施使用'>
        <EAFUseList selectKey={selectKey}></EAFUseList>
      </TabPane>
      <TabPane key='2' tab='设备设施养护'>
        <EAFConserveList selectKey={selectKey}></EAFConserveList>
      </TabPane>
      <TabPane key='3' tab='设备设施登记记录'>
        <EAFRegisterRecordList selectKey={selectKey}></EAFRegisterRecordList>
      </TabPane>
      <TabPane key='4' tab='设备设施使用记录'>
        <EAFUseRecordList selectKey={selectKey}></EAFUseRecordList>
      </TabPane>
      <TabPane key='5' tab='设备设施养护记录'>
        <EAFConserveRecordList selectKey={selectKey}></EAFConserveRecordList>
      </TabPane>
    </TabBar>
  )
}
